import { Reducer } from 'redux'
import { toast } from 'react-toastify'
import { call, put, takeLatest, all } from 'redux-saga/effects'
import { SagaAction, GetResponse } from 'src/@types'
import { setLoading } from './loading'
import { API } from 'src/services/config'

export interface LocationsProps {
  aguados: string,
  area: number,
  cerca: string,
  classificacao: string,
  dataCriacao: string,
  descricao: string,
  id: string,
  idFazenda: string,
  idPasto: string,
  key: string,
  saleiros: string,
}

export interface LocationsStoreProps {
  aguados?: string,
  area?: number,
  cerca?: string,
  classificacao?: string,
  dataCriacao?: string,
  descricao?: string,
  id?: string,
  idFazenda?: string,
  idPasto?: string,
  key?: string,
  saleiros?: string,
}

export interface LocationsState {
  list: Array<LocationsProps>
}

const customModule = '@LOCATIONS'

const GET = {
  REQUEST: `${customModule}/GET_REQUEST`,
  SUCCESS: `${customModule}/GET_SUCCESS`,
}

const STORE = {
  REQUEST: `${customModule}/STORE_REQUEST`,
  SUCCESS: `${customModule}/STORE_SUCCESS`,
}

const UPDATE = {
  REQUEST: `${customModule}/UPDATE_REQUEST`,
  SUCCESS: `${customModule}/UPDATE_SUCCESS`,
}

const SET_FETCHING = `${customModule}/SET_FETCHING`

const initialState: LocationsState = {
  list: [],
}

export const locationsReducer: Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case GET.SUCCESS:
    return { ...state, list: payload }

  case STORE.SUCCESS: {
    const { list } = state
    const newList = [...list]
    newList.unshift(payload)
    return { ...state, list: newList }
  }

  case UPDATE.SUCCESS: {
    const { list } = state
    const newList = list.map((item: any) => {
      if (item.idPasto === payload.idPasto) return payload
      return item
    })
    return { ...state, list: newList }
  }
  default:
    return state
  }
}

export const setFetching = (data: boolean) => ({ type: SET_FETCHING, payload: data })
export const getLocations = (data: string) => ({ type: GET.REQUEST, payload: data })
export const createLocations = (data: LocationsStoreProps) => ({ type: STORE.REQUEST, payload: data })
export const updateLocations = (data: LocationsStoreProps) => ({ type: UPDATE.REQUEST, payload: data })


const ROUTE = 'entity/Pasto'

// eslint-disable-next-line
function* get({ payload }: SagaAction<string>) {
  try {
    yield put(setLoading(true))
    const { data }: GetResponse<any> = yield call(API.get, `${ROUTE}/${payload}`)
    const farmList = data.filter((item: any) => item.idFazenda === payload)
    yield put({ type: GET.SUCCESS, payload: farmList })
    yield put(setLoading(false))
  } catch (error: any) {
    const message = error?.response?.data || 'Erro ao buscar Locais'
    toast.error(message)
    yield put(setLoading(false))
  }
}

// eslint-disable-next-line
function* store({ payload }: SagaAction<LocationsStoreProps>) {
  try {
    yield put(setFetching(true))
    const { data }: GetResponse<any> = yield toast.promise(
      API.put(ROUTE, payload),
      {
        pending: 'Processando...',
        success: {
          render() {
            return 'Cadastrado com Sucesso!'
          },
          delay: 800,
        },
        error: {
          render({ data: { response } }: any) {
            return response?.data || 'Erro ao Cadastrar'
          },
          delay: 800,
        },
      },
    )
    yield put({ type: STORE.SUCCESS, payload: data })
    yield put(setFetching(false))
  } catch {
    yield put(setFetching(false))
  }
}

// eslint-disable-next-line
function* update({ payload }: SagaAction<LocationsStoreProps>) {
  try {
    yield put(setFetching(true))
    const { data }: GetResponse<any> = yield toast.promise(
      API.put(ROUTE, payload),
      {
        pending: 'Processando...',
        success: {
          render() {
            return 'Atualizado com Sucesso!'
          },
          delay: 800,
        },
        error: {
          render({ data: { response } }: any) {
            return response?.data || 'Erro ao Atualizar'
          },
          delay: 800,
        },
      },
    )
    yield put({ type: UPDATE.SUCCESS, payload: data })
    yield put(setFetching(false))
  } catch {
    yield put(setFetching(false))
  }
}

export const locationsSaga = all([
  takeLatest(GET.REQUEST, get),
  takeLatest(STORE.REQUEST, store),
  takeLatest(UPDATE.REQUEST, update),

])
